module.exports = __webpack_public_path__ + "img/DE01323.a7816214.png";